import { useState } from 'react'
import { Alert, Button, Card, Group, Stack, Text, Title } from '@mantine/core'
import { notifications } from '@mantine/notifications'
import { IconDatabaseImport, IconInfoCircle } from '@tabler/icons-react'
import { Navigation } from './components'
import { useMiddlewareClient } from '@/hooks'

type UpsertTerminologiesResponse = {
  id?: string
  count?: number
}

export function Terminology() {
  const middleware = useMiddlewareClient()
  const [isLoading, setIsLoading] = useState(false)
  const [lastResult, setLastResult] = useState<UpsertTerminologiesResponse | null>(null)

  const upsertTerminologies = async () => {
    try {
      setIsLoading(true)
      const response = await middleware.post('/super/upsert-terminologies')
      setLastResult(response)
      notifications.show({
        color: 'green',
        title: 'Terminologies updated',
        message: `Upsert completed. Concepts: ${response.count ?? 0}`,
      })
    } catch (error) {
      notifications.show({
        color: 'red',
        title: 'Upsert failed',
        message: (error as Error)?.message || 'Failed to upsert terminologies',
      })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <>
      <Navigation />
      <div className="px-6 py-4">
        <Title order={2} mb="md">
          Terminology
        </Title>

        <Stack gap="md" maw={820}>
          <Alert variant="light" icon={<IconInfoCircle size={18} />}>
            Run system terminology upsert from middleware. This action will create or update
            ICD-10-CM CodeSystem resources.
          </Alert>

          <Card withBorder shadow="sm" radius="md" p="lg">
            <Stack gap="md">
              <Group justify="space-between" align="center">
                <div>
                  <Text fw={600}>ICD-10-CM Upsert</Text>
                  <Text c="dimmed" size="sm">
                    Source: middleware super terminology pipeline
                  </Text>
                </div>
                <Button
                  leftSection={<IconDatabaseImport size={18} />}
                  loading={isLoading}
                  onClick={upsertTerminologies}
                >
                  Upsert Terminologies
                </Button>
              </Group>

              {lastResult && (
                <Text size="sm" c="dimmed">
                  Last run result: CodeSystem ID `{lastResult.id ?? '-'}`, concepts `
                  {lastResult.count ?? 0}`.
                </Text>
              )}
            </Stack>
          </Card>
        </Stack>
      </div>
    </>
  )
}
